import { createSelector } from '@ngrx/store';
import { selectStoreState } from '../store.selectors';
import { ContextSearchViewModel } from './context.models';
import { contextAdapter, ContextKey } from './context.reducer';

export const selectContextState = createSelector(
  selectStoreState,
  (state) => state[ContextKey]
);

export const {
  selectAll: selectAllContext,
  selectEntities: selectContextEntities,
} = contextAdapter.getSelectors(selectContextState);

export const selectContextSearchViewModel = createSelector(
  selectContextState,
  selectAllContext,
  (state, contexts): ContextSearchViewModel => {
    return {
      contexts,
      error: state.error,
      loading: state.loading,
    };
  }
);
